export default __webpack_public_path__ + "static/media/NIAS0570.34I-40566_-23982_0.a4b16369.jpg";